// 오른쪽 사이드바 (width: 680px)
import React from 'react';

import styles from './styles/side-bar-right.module.css';

export default function SideBarRight({ header, content }) {
    return (
        <div className={styles.wrapper}>
            {header && <div className={styles.header}>{header}</div>}
            <div className={styles.content}>{content}</div>
        </div>
    );
}
